import * as React from 'react';
type IconDefinicionesComercialesProps = React.SVGProps<SVGSVGElement>;

export const IconDefinicionesComerciales: React.FC<IconDefinicionesComercialesProps> = (props) => (
	<svg
		width={60}
		height={64}
		viewBox="0 0 60 64"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.389008"
			y="0.165344"
			width="46.6671"
			height="55.5575"
			rx="4.44454"
			fill="#EBF8F0"
		/>
		<path
			d="M9.27657 9.05597L38.1657 9.05597"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<path
			d="M9.27657 17.9466L38.1657 17.9466"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<path
			d="M9 27H21"
			stroke="#FFA692"
			stroke-width="3.95968"
			stroke-linecap="round"
		/>
		<ellipse
			cx="40.3889"
			cy="44.6121"
			rx="19.2221"
			ry="19.2226"
			fill="#7EAE90"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M35.5517 50.7116H33.1767C32.5933 50.7116 32.0339 50.4829 31.6213 50.0758L30.0598 48.5348C29.987 48.4629 29.8883 48.4226 29.7853 48.4226H29.1996C27.9848 48.4226 27 47.4507 27 46.2519V38.8873C27 37.6885 27.9848 36.7166 29.1996 36.7166H32.2718C32.3442 36.7166 32.4151 36.6967 32.4766 36.659L34.652 35.3264C35.0003 35.1131 35.4021 35 35.8121 35H42.8316C43.415 35 43.9745 35.2287 44.387 35.6358L47.8015 39.0055H52.8004C54.0152 39.0055 55 39.9773 55 41.1762V47.5392C55 48.738 54.0152 49.7099 52.8004 49.7099H51.2965C51.1936 49.7099 51.0949 49.7503 51.0221 49.8221L45.4061 55.3642C44.5471 56.2119 43.1544 56.2119 42.2954 55.3642L41.0482 54.1335C40.2361 54.5013 39.2438 54.3551 38.5749 53.6951L35.5517 50.7116Z"
			fill="#EBF8F0"
		/>
		<path
			d="M34.4526 50.1263L32.5904 48.264C32.0274 47.701 32.0274 46.7882 32.5904 46.2252L38.6857 40.1299C38.9561 39.8595 39.3228 39.7076 39.7051 39.7076H41.8487C42.2311 39.7076 42.5978 39.8595 42.8681 40.1299L45.6796 42.9414C46.2426 43.5044 47.1554 43.5044 47.7184 42.9414L48.4791 42.1807C49.0421 41.6177 49.0421 40.7049 48.4791 40.1419L48.0449 39.7076M34.4526 50.1263L38.9748 45.6042M34.4526 50.1263L35.2323 50.9059M37.2935 52.9671L41.2234 49.0372M37.2935 52.9671L38.8963 54.57C39.4593 55.133 40.3721 55.133 40.9351 54.57L41.0461 54.459M37.2935 52.9671L35.2323 50.9059M43.5226 51.9825L41.0461 54.459M41.0461 54.459L43.0416 56.4544C43.6046 57.0174 44.5174 57.0174 45.0804 56.4544L51.3376 50.1972C51.6079 49.9269 51.9746 49.775 52.357 49.775H54.0325C54.8287 49.775 55.4742 49.1295 55.4742 48.3333V41.1493C55.4742 40.3531 54.8287 39.7076 54.0325 39.7076H48.0449M48.0449 39.7076L43.9449 35.6076C43.6745 35.3373 43.3078 35.1854 42.9255 35.1854H35.1044C34.8357 35.1854 34.5724 35.2604 34.3441 35.4021L31.9202 36.9067C31.692 37.0484 31.4286 37.1235 31.1599 37.1235H27.7369C26.9407 37.1235 26.2953 37.7689 26.2953 38.5651V46.8799C26.2953 47.6761 26.9407 48.3216 27.7369 48.3216H28.3895C28.7718 48.3216 29.1385 48.4734 29.4089 48.7438L31.1488 50.4837C31.4191 50.754 31.7858 50.9059 32.1681 50.9059H35.2323"
			stroke="#7EAE90"
			stroke-width="2.0183"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export default IconDefinicionesComerciales;
